var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modifier-side-popup",class:[
    _vm.openPopup ? 'open-popup' : 'close-popup',
    _vm.itemModifierGroups(_vm.item).length ? '' : 'without-modifier',
  ],attrs:{"id":"modal-1"}},[_c('div',{staticClass:"modal-dialog customized-modal",attrs:{"role":"document"}},[_c('div',{ref:"modifiers-selection-modal",staticClass:"modal-content"},[_c('div',{staticClass:"modal-body ratio_portrait"},[_c('Top'),_c('div',{staticClass:"customized-detail"},[_c('ItemInfo'),_c('Modifiers'),_c('Bottom')],1)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }